<template>
    <div class="d-flex flex-1 h-100 overflow-auto delegation">
        <v-card class="report-container w-100  p-0" style="border-radius: 12px; margin-bottom: 24px">
            <v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_label_ManageDynamicForms") }}</v-toolbar-title>
            </v-toolbar>
            <!------------------------------------------------------------------------->
            <div class="border-top p-4 flex-1 overflow-auto">
                <div class="row align-items-start m-0 gap-2">
                    <div class="flex-1 p-0 col-6">
                        <v-label class="label_required mb-1">{{ $t("res_Label_Category") }} *</v-label>
                        <div class="with-absolute-button">
                            <multi-select class="light-bg" :options="CategoriesList" v-model="selectedCategory"
                                          label="name" track-by="id" open-direction="bottom"
                                          :searchable="false" :internal-search="false" :clear-on-select="false" :close-on-select="true"
                                          :options-limit="300" :max-height="600" :show-no-results="false"
                                          :hide-selected="false" :multiple="false" :placeholder="$t('res_Label_SelectOption')"
                                          @input="(item) => handleSelect(item,'selectedCategory')">
                                <template slot="option" slot-scope="props">
                                    <div class="mt-1" style="width: 100%; display: flex;text-align:start;">
                                        <div class="ad__box">
                                            <p class="ad__text__bold">{{ props.option.name }}</p>
                                        </div>
                                    </div>
                                </template>
                            </multi-select>
                        </div>
                    </div>
                    <div class="p-0 col-6">
                        <v-label class="label_required mb-1">{{ $t("res_Label_Structure") }}<span> *</span></v-label>
                        <div class="with-absolute-button">
                            <StructureUserSelector :showInternalStructures="true" :showExternalStructures="true" :excludeSelf="false" :isMultiple="false"
                                                   :selectedStructureUser="selectedStructure"
                                                   @structureUserSelectChanged="(item) => handleSelect(item,'selectedStructure')">
                            </StructureUserSelector>
                        </div>
                    </div>
                </div>
                <div class="row align-items-start m-0 gap-2 mt-4" :class="{ 'disabled': !isValidForm }">
                    <div class="flex-1 p-0 col-6">
                        <v-label class="label_required mb-1">{{ $t("res_label_Template") }} </v-label>
                        <div class="with-absolute-button">
                            <multi-select class="light-bg" :options="templatesList" v-model="selectedTemplate" label="name" track-by="id"
                                          open-direction="bottom" :searchable="true"
                                          :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                                          :max-height="600" :show-no-results="false" :hide-selected="true" :multiple="false" :disabled="disabledTemplate"
                                          @search-change="getAllTemplates" @close="templatesList = []"
                                          :allow-empty="false" ref="multiselect1" :placeholder="$t('res_MenuItems_ChooseTemplate')">
                                <template slot="option" slot-scope="props">
                                    <div style="height: 50px; width: 100%; display: flex;text-align:start">
                                        <div class="ad__box">
                                            <p class="ad__text__bold">{{ props.option.name }}</p>
                                        </div>
                                    </div>
                                </template>
                                <template slot="noOptions" slot-scope="props">
                                    <div style="text-align:start">
                                        {{ $t("res_Msgs_EmptySearch") }}
                                    </div>
                                </template>
                            </multi-select>
                        </div>
                    </div>
                    <div class="flex-1 p-0 col-6 align-self-end ml-16">
                        <v-btn class="primary" @click="OpenDialog()">{{ $t("res_ButtonText_AddEditDynamicForms") }}</v-btn>
                    </div>
                </div>

            </div>
        </v-card>
        <div v-if="ShowDynamicFormBuilder">
            <DynamicFomrBuilder :category_id="dynamicFormFilter.categoryId"
                                :template_id="dynamicFormFilter.templateId"
                                :structure_id="dynamicFormFilter.structureId"
                                :key="formBuilderComponentKey"
                                @close-dialog="closeDynamicFormBuilder">
            </DynamicFomrBuilder>
        </div>

    </div>
</template>

<script>
    import axios from 'axios';
    import constants from '@/assets/js/constants';
    import router from '@/router/index.js'
    import StructureUserSelector from '@/components/StructureUserSelector.vue'
    import MultiSelect from 'vue-multiselect'
    import * as utils from '@/assets/js/common.js'
    import DynamicFomrBuilder from '@/components/DynamicFomrBuilder.vue'
    import _ from '@/assets/js/dynamic-froms';

    export default {
        name: 'ManageDynamicForms',
        components: {
            StructureUserSelector, MultiSelect, DynamicFomrBuilder
        },
        data: () =>
        ({
            CategoriesList: [],
            templatesList: [],
            selectedCategory: null,
            selectedStructure: null,
            selectedTemplate: null,
            utils: utils,
            isValidForm: false,
            dynamicFormFilter: { id: '', templateName: '', templateId: '', referenceNumber: '', structureId: 0, categoryId: 0 },
            ShowDynamicFormBuilder: false,
            formBuilderComponentKey: 0,
            disabledTemplate:false
        }),
        mounted() {
            this.GetAllCategory();

        },
        watch: {
            selectedStructure(newVal) {
                this.selectedStructure = newVal;
            },
            selectedCategory:function(newval,oldVal){
                if (newval != oldVal){
                    this.selectedTemplate = null
                    this.templatesList = []
                }

                if(newval.id == constants.categoriesEnum.Incoming)
                    this.disabledTemplate = true
                else 
                    this.disabledTemplate = false
            },
            selectedStructure:function(newval,oldVal){
                if (newval != oldVal){
                    this.selectedTemplate = null;
                    this.templatesList = []
                }
            }
        },
        methods: {
            backToAdminPage() {
                router.push({ name: 'admin' })
            },
            GetAllCategory() {
                axios.get(constants.baseApiUrl + "Admin/GetAllCategory")
                    .then(response => {
                        this.CategoriesList = response.data;
                    }).catch((err) => console.warn(err));
            },
            getAllTemplates(search) {

                axios.get(constants.baseApiUrl + 'Template/GetTemplatesByStructureId?structureId=' + this.selectedStructure.id + '&name=' + search
                    + '&pageIndex=' + 0 + '&pageSize=' + 50)
                    .then((res) => {
                        if (res.data != undefined && res.data != null && res.data.length > 0) {
                            res.data.forEach(item => item.name = item.itemName);
                            this.templatesList = res.data;
                        }
                        else
                            this.templatesList = [];
                    })
                    .catch((err) => console.log(err));
            },
            handleSelect(item, mode) {
                if (mode == 'selectedCategory')
                    this.selectedCategory = item;
                if (mode == 'selectedStructure')
                    this.selectedStructure = item;

                if (utils.CheckIfNullOrEmpty(this.selectedCategory) || utils.CheckIfNullOrEmpty(this.selectedStructure)) {
                    this.isValidForm = false;
                    this.selectedTemplate = null;
                    this.dynamicFormFilter = { id: '', templateName: '', templateId: '', referenceNumber: '', structureId: 0, categoryId: 0 };
                }
                else
                    this.isValidForm = true;
            },
            OpenDialog() {
                this.dynamicFormFilter.categoryId = this.selectedCategory.id;
                this.dynamicFormFilter.structureId = this.selectedStructure.id;
                if (!utils.CheckIfNullOrEmpty(this.selectedTemplate))
                    this.dynamicFormFilter.templateId = this.selectedTemplate.id
                this.ShowDynamicFormBuilder = true;
                this.formBuilderComponentKey += 1;
            },
            closeDynamicFormBuilder() {
                this.ShowDynamicFormBuilder = false;
            }

        },
    }
</script>